import styled from 'styled-components'
import { Form } from '@unform/web';



export const FormWrapper = styled(Form)`
> div:not(:last-child) {
  margin-bottom: 1rem;
}

p.MuiFormHelperText-root.Mui-error {
  margin-top: 0;
}
`;